export const DAILY_REPORT = {
  Summary: '/report/daily',
  ExportSummary: '/report/daily/export',
  Details: '/report/daily/details',
  ExportDetails: '/report/daily/export-details',
};
